import React from 'react';

interface Props {
  suggestions: string[];
  onClick: (string) => void;
}

const DidYouMean: React.FunctionComponent<Props> = ({
  suggestions,
  onClick,
}) => {
  if (!suggestions.length) {
    return null;
  }

  return (
    <div className="did-you-mean">
      <span>Did you mean: </span>
      {suggestions.map((term, i) => (
        <strong key={term}>
          {i > 0 ? ', ' : ''}
          <a onClick={(): void => onClick(term)}>{term}</a>
        </strong>
      ))}
    </div>
  );
};

export default DidYouMean;
